import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import AddonsList from "./AddonsList";
import LoaderMini from "../Loader/LoaderMini";
import { fetchAddonsByCategory } from "../../redux/slices/addonsSlice";
import { fetchAddonsCategories } from "../../redux/slices/addonsCategoriesSlice";
import { useTranslation } from "react-i18next";

const MultiSectionAddons = ({ handleAddonQuantityChange, selectedAddons, handleAddonChange }) => {
    const dispatch = useDispatch();
    const { addons: categories, loading, error } = useSelector((state) => state.addonsCategories);
    const [selectedCategory, setSelectedCategory] = useState(24);
    const { t, i18n } = useTranslation();
    useEffect(() => {
        dispatch(fetchAddonsCategories());
    }, [dispatch]);
    const selectedCity = useSelector((state) => state.citySelection.selectedCity);

    useEffect(() => {
        if (selectedCategory && selectedCity) {
            dispatch(fetchAddonsByCategory(selectedCategory));
        }
    }, [dispatch, selectedCategory, selectedCity]);

    if (loading) return <div><LoaderMini color="bg-purble-2" /></div>;
    if (error) return <p className="text-red-500">{t("error")}: {error}</p>;

    return (
        <div className="flex flex-col w-full flex-shrink-0 mt-4">
            <h2 className="text-2xl font-bold mb-4">{t("addons")}</h2>
            <div className="flex gap-4 overflow-x-auto pb-4 border-b flex-shrink-0">
                {categories.map((category) => (
                    <button
                        key={category.id}
                        onClick={() => setSelectedCategory(category.id)}
                        className={`p-2 border rounded-2xl flex flex-col 
                        items-center gap-1 
                        ${selectedCategory === category.id
                                ? "bg-purble-2 text-white"
                                : "bg-white"
                            }`}
                    >
                        <img src={category.website_image}
                            alt={i18n.language === "en"
                                ? category?.english_name
                                : category?.arabic_name}
                            className="w-16 h-16 rounded" />
                        <p className="text-sm font-medium">{i18n.language === "en"
                            ? category?.english_name
                            : category?.arabic_name}</p>
                    </button>
                ))}
            </div>
            {selectedCategory && <AddonsList categoryId={selectedCategory} handleAddonChange={handleAddonChange}
                selectedAddons={selectedAddons}
                handleAddonQuantityChange={handleAddonQuantityChange} />}
        </div>
    );
};

export default MultiSectionAddons;
